module.exports = __webpack_public_path__ + "static/media/Mobile_Workshop_INTELIGENCIA_EM_CYBERSECURITY_COM_ETHICAL_HACKING (1).fe31d3e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/intelCyberEthical/Mobile_Workshop_INTELIGENCIA_EM_CYBERSECURITY_COM_ETHICAL_HACKING (1).png
// module id = 86
// module chunks = 0